import { Component, Input } from '@angular/core';
import { ProleisObject } from 'proleis-rest-client';

@Component({
  selector: 'p4m-pos-params-info',
  templateUrl: './pos-params.info.component.html',
  styleUrls: ['./pos-params.info.component.scss'],
})
export class PosParamsInfoComponent {
  @Input()
  pos: ProleisObject;
}
